import React, { useEffect, useState } from 'react';
import feather from 'feather-icons';
import { Link } from 'react-router-dom';
import SuccessToast from '../../toast/SuccessToast';
import AddCard from '../Modals/AddCard';
import { useLanguage } from '../../context/LanguageContext';

function CardListHeader({ showAdd = false, onCardAdd }) {
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const { t } = useLanguage();

    const handleShow = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };
    useEffect(() => {
        feather.replace();
    }, []);

    return (
        <>
            <header className="section-t-space">
                <div className="custom-container">
                    <div className="header-panel">
                        <Link to="/" className="back-btn">
                            <i className="icon" data-feather="arrow-left"></i>
                        </Link>
                        <h2>{t('myCards')}</h2>
                        {showAdd && (
                            <Link to="#" onClick={handleShow} className="back-btn">
                                <i className="icon" data-feather="plus"></i>
                            </Link>
                        )}
                    </div>
                </div>
            </header>
            {showModal && (
                <AddCard
                    show={showModal}
                    onClose={handleClose}
                    setShowToast={setShowToast}
                    onCardAdd={onCardAdd}
                />
            )}

            {showToast && (
                <SuccessToast message="Card Add Successful!" onClose={() => setShowToast(false)} />
            )}
        </>
    );
}

export default CardListHeader;
